import { SchoolsType } from '../../types/apiResponse/selectSchoolsTypes'
import { getData } from '../../utils'
import { toast } from '@/utils/toast'

export const getSchools = async (groupId: string) => {
  const result = await getData<SchoolsType>(`/school-diagram?group_id=${groupId}`)
    .then((response) => response)
    .catch(() => {
      toast.error('ERROR!')
      return null
    })

  return result
}
